import React from 'react';
import {GridOverlay} from '@mui/x-data-grid-pro';
import Loading from '../Loading/Loading';

function LoadingOverlay() {
  return (
    <GridOverlay>
      <Loading />
    </GridOverlay>
  );
}

export default LoadingOverlay;
